function formatNumberAbbreviated(amount) {
  const cleanAmount = parseFloat(String(amount).replace(/,/g, ''));

  if (Number.isNaN(cleanAmount)) return amount;

  const absoluteAmount = Math.abs(cleanAmount);
  if (absoluteAmount < 100) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cleanAmount);
  }

  if (absoluteAmount < 1000) {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 0,
    }).format(Math.round(cleanAmount));
  }

  const suffixes = ['', 'K', 'M', 'B', 'T'];
  const suffixIndex = Math.min(Math.floor(Math.log10(absoluteAmount) / 3), suffixes.length - 1);
  const scaledAmount = cleanAmount / (1000 ** suffixIndex);
  const leadingDigits = Math.floor(Math.abs(scaledAmount));
  const maximumFractionDigits = leadingDigits < 100 ? 1 : 0;

  return `${new Intl.NumberFormat('en-US', {
    maximumFractionDigits,
  }).format(scaledAmount)}${suffixes[suffixIndex]}`;
}

export const PAY_RATE_UNITS = {
  hour: '/hr',
  hourly: '/hr',
  day: '/daily',
  daily: '/daily',
  week: '/wk',
  weekly: '/wk',
  '2-wks': '/2-wks',
  '2 weeks': '/2-wks',
  biweekly: '/2-wks',
  month: '/mo',
  monthly: '/mo',
  year: '/yr',
  yearly: '/yr',
  once: '/once',
  'semi-mo': '/semi-mo',
  'semi-monthly': '/semi-mo',
  semimonthly: '/semi-mo',
};

const SALARY_UNIT_REGEX = /\/(?:2-wks|semi-mo|daily|once|year|month|week|hour|yr|mo|wk|hr|day)s?/i;

const getPayRateUnit = payRate => {
  if (!payRate) return '';
  const normalized = String(payRate).trim().toLowerCase().replace(/_/g, '-');
  return PAY_RATE_UNITS[normalized] || '';
};

export function formatSalaryString(salaryString, payRate) {
  if (salaryString === null || salaryString === undefined || salaryString === '') return '';

  const rawSalary = String(salaryString);
  // Prefer currency-prefixed values so digits in units such as `/2-wks`
  // are never mistaken for the maximum salary.
  const currencyMatches = rawSalary.match(/\$([\d,]+(?:\.\d{1,2})?)/g) || [];
  const amountMatches = currencyMatches.length
    ? currencyMatches
    : rawSalary.match(/(?<![\w/])([\d,]+(?:\.\d{1,2})?)/g) || [];
  const amountsRaw = amountMatches
    .map(value => value.replace(/^\$/, ''))
    .filter(value => !Number.isNaN(parseFloat(value.replace(/,/g, ''))));

  if (!amountsRaw.length) return rawSalary;

  const min = formatNumberAbbreviated(amountsRaw[0]);
  const hasRange = /\s-\s|\s*-\s*\$/.test(rawSalary);
  const max = amountsRaw.length > 1 && hasRange ? formatNumberAbbreviated(amountsRaw[1]) : null;
  const unitMatch = rawSalary.match(SALARY_UNIT_REGEX);
  const unit = unitMatch ? unitMatch[0].toLowerCase() : getPayRateUnit(payRate);

  let result = `$${min}`;
  if (max && min !== max) result += `-$${max}`;
  return `${result}${unit}`;
}

export const formatJobSalary = job =>
  formatSalaryString(
    job?.salary ?? job?.salary_range ??
      (job?.minsalary !== undefined || job?.maxsalary !== undefined
        ? `$${job?.minsalary ?? ''} - $${job?.maxsalary ?? ''}`
        : ''),
    job?.pay_rate
  );
